module.exports = "<input type=\"text\" [(ngModel)]=\"description\" />\n{{description}}\n<button (click)=\"addDesc()\">Press</button>"


//////////////////
// WEBPACK FOOTER
// ./src/app/test/test.component.html
// module id = ./src/app/test/test.component.html
// module chunks = main